var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "d-flex flex-wrap align-center mb-3"
        },
        [
          _c(
            "span",
            {
              staticClass: "kvm-help text-caption mr-auto"
            },
            [
              _vm._v(
                "Every container on this server, including the ones your apps run."
              )
            ]
          ),
          _c(
            "gg-btn",
            {
              staticClass: "mr-2 mb-1",
              attrs: {
                small: "",
                tile: "",
                outlined: "",
                color: "primary",
                loading: _vm.loading
              },
              on: {
                click: _vm.load
              }
            },
            [
              _c(
                "v-icon",
                {
                  attrs: {
                    left: "",
                    small: "",
                    "aria-hidden": "true"
                  }
                },
                [_vm._v("mdi-refresh")]
              ),
              _vm._v("Refresh ")
            ],
            1
          ),
          _c(
            "gg-btn",
            {
              staticClass: "mb-1 kvm-dk-primary",
              attrs: {
                small: "",
                tile: "",
                color: "primary"
              },
              on: {
                click: _vm.openRun
              }
            },
            [
              _c(
                "v-icon",
                {
                  attrs: {
                    left: "",
                    small: "",
                    "aria-hidden": "true"
                  }
                },
                [_vm._v("mdi-play-box-outline")]
              ),
              _vm._v("Run container ")
            ],
            1
          )
        ],
        1
      ),
      _vm.error
        ? _c(
            "v-alert",
            {
              attrs: {
                type: "error",
                border: "left",
                dense: "",
                role: "alert"
              }
            },
            [_vm._v(_vm._s(_vm.error))]
          )
        : _vm._e(),
      _vm.loading && !_vm.loaded
        ? _c(
            "div",
            {
              staticClass: "py-6 text-center",
              attrs: {
                role: "status"
              }
            },
            [
              _c("v-progress-circular", {
                attrs: {
                  indeterminate: "",
                  color: "primary",
                  size: "32",
                  width: "3"
                }
              }),
              _c(
                "span",
                {
                  staticClass: "kvm-sr-only"
                },
                [_vm._v("Loading containers…")]
              )
            ],
            1
          )
        : _vm.loaded && !_vm.containers.length
        ? _c(
            "p",
            {
              staticClass: "kvm-help my-6 text-center"
            },
            [
              _vm._v(
                " No containers yet. Run one here, or deploy an app from the Apps tab. "
              )
            ]
          )
        : _vm.containers.length
        ? _c(
            "v-simple-table",
            {
              staticClass: "kvm-dk-table",
              attrs: {
                dense: ""
              }
            },
            [
              _c(
                "caption",
                {
                  staticClass: "kvm-sr-only"
                },
                [_vm._v("Containers")]
              ),
              _c("thead", [
                _c("tr", [
                  _c(
                    "th",
                    {
                      attrs: {
                        scope: "col"
                      }
                    },
                    [_vm._v("Name")]
                  ),
                  _c(
                    "th",
                    {
                      attrs: {
                        scope: "col"
                      }
                    },
                    [_vm._v("Image")]
                  ),
                  _c(
                    "th",
                    {
                      attrs: {
                        scope: "col"
                      }
                    },
                    [_vm._v("State")]
                  ),
                  _c(
                    "th",
                    {
                      attrs: {
                        scope: "col"
                      }
                    },
                    [_vm._v("Ports")]
                  ),
                  _c(
                    "th",
                    {
                      attrs: {
                        scope: "col"
                      }
                    },
                    [_vm._v("App")]
                  ),
                  _c(
                    "th",
                    {
                      staticClass: "text-right",
                      attrs: {
                        scope: "col"
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "kvm-sr-only"
                        },
                        [_vm._v("Actions")]
                      )
                    ]
                  )
                ])
              ]),
              _c(
                "tbody",
                _vm._l(_vm.containers, function(c) {
                  return _c(
                    "tr",
                    {
                      key: c.id
                    },
                    [
                      _c(
                        "td",
                        {
                          staticClass: "font-weight-medium",
                          attrs: {
                            "data-label": "Name"
                          }
                        },
                        [
                          _vm._v(" " + _vm._s(c.name) + " "),
                          _vm.isSystem(c)
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "ml-1",
                                  attrs: {
                                    "x-small": "",
                                    label: "",
                                    title:
                                      "Runs your domains — can be restarted, not stopped or removed"
                                  }
                                },
                                [_vm._v("domains")]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "td",
                        {
                          staticClass: "kvm-dk-mono",
                          attrs: {
                            "data-label": "Image"
                          }
                        },
                        [_vm._v(_vm._s(c.image))]
                      ),
                      _c(
                        "td",
                        {
                          attrs: {
                            "data-label": "State"
                          }
                        },
                        [
                          _c(
                            "v-chip",
                            {
                              attrs: {
                                "x-small": "",
                                label: "",
                                color: _vm.stateColor(c.state),
                                "text-color": "grey darken-4"
                              }
                            },
                            [_vm._v(_vm._s(c.state))]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "kvm-help text-caption"
                            },
                            [_vm._v(_vm._s(c.status))]
                          )
                        ],
                        1
                      ),
                      _c(
                        "td",
                        {
                          staticClass: "kvm-dk-mono text-caption",
                          attrs: {
                            "data-label": "Ports"
                          }
                        },
                        [_vm._v(_vm._s(c.ports || "—"))]
                      ),
                      _c(
                        "td",
                        {
                          attrs: {
                            "data-label": "App"
                          }
                        },
                        [_vm._v(_vm._s(c.stack || "—"))]
                      ),
                      _c(
                        "td",
                        {
                          staticClass: "text-right text-no-wrap",
                          attrs: {
                            "data-label": "Actions"
                          }
                        },
                        [
                          c.state !== "running"
                            ? _c(
                                "gg-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "aria-label": "Start " + c.name,
                                    disabled: !!_vm.busy[c.name]
                                  },
                                  on: {
                                    click: function click($event) {
                                      return _vm.act(c, "start")
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        small: ""
                                      }
                                    },
                                    [_vm._v("mdi-play")]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          c.state === "running"
                            ? _c(
                                "gg-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "aria-label": "Restart " + c.name,
                                    disabled: !!_vm.busy[c.name]
                                  },
                                  on: {
                                    click: function click($event) {
                                      return _vm.act(c, "restart")
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        small: ""
                                      }
                                    },
                                    [_vm._v("mdi-restart")]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          c.state === "running" && !_vm.isSystem(c)
                            ? _c(
                                "gg-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "aria-label": "Stop " + c.name,
                                    disabled: !!_vm.busy[c.name]
                                  },
                                  on: {
                                    click: function click($event) {
                                      return _vm.act(c, "stop")
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        small: ""
                                      }
                                    },
                                    [_vm._v("mdi-stop")]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "gg-btn",
                            {
                              attrs: {
                                icon: "",
                                small: "",
                                "aria-label": "Logs for " + c.name
                              },
                              on: {
                                click: function click($event) {
                                  return _vm.openLogs(c)
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: {
                                    small: ""
                                  }
                                },
                                [_vm._v("mdi-text-box-outline")]
                              )
                            ],
                            1
                          ),
                          !_vm.isSystem(c)
                            ? _c(
                                "gg-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "aria-label": "Remove " + c.name,
                                    disabled: !!_vm.busy[c.name]
                                  },
                                  on: {
                                    click: function click($event) {
                                      return _vm.confirmRemove(c)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        small: "",
                                        color: "error"
                                      }
                                    },
                                    [_vm._v("mdi-delete-outline")]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.busy[c.name]
                            ? _c("v-progress-circular", {
                                staticClass: "ml-1",
                                attrs: {
                                  indeterminate: "",
                                  size: "14",
                                  width: "2"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                }),
                0
              )
            ]
          )
        : _vm._e(),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "900"
          },
          model: {
            value: _vm.logs.open,
            callback: function callback($$v) {
              _vm.$set(_vm.logs, "open", $$v)
            },
            expression: "logs.open"
          }
        },
        [
          _c(
            "gg-card",
            {
              attrs: {
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "kvm-dk-logs-title"
              }
            },
            [
              _c(
                "gg-card-text",
                {
                  staticClass: "pa-4"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex align-center mb-2"
                    },
                    [
                      _c(
                        "h3",
                        {
                          staticClass: "body-1 mr-auto",
                          attrs: {
                            id: "kvm-dk-logs-title"
                          }
                        },
                        [_vm._v("Logs — " + _vm._s(_vm.logs.name))]
                      ),
                      _c("v-select", {
                        staticClass: "mr-2",
                        staticStyle: {
                          "max-width": "110px"
                        },
                        attrs: {
                          items: [100, 200, 500, 1000, 2000],
                          dense: "",
                          outlined: "",
                          "hide-details": "",
                          label: "Lines"
                        },
                        on: {
                          change: _vm.loadLogs
                        },
                        model: {
                          value: _vm.logs.tail,
                          callback: function callback($$v) {
                            _vm.$set(_vm.logs, "tail", $$v)
                          },
                          expression: "logs.tail"
                        }
                      }),
                      _c(
                        "gg-btn",
                        {
                          attrs: {
                            small: "",
                            tile: "",
                            outlined: "",
                            color: "primary",
                            loading: _vm.logs.loading
                          },
                          on: {
                            click: _vm.loadLogs
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                left: "",
                                small: "",
                                "aria-hidden": "true"
                              }
                            },
                            [_vm._v("mdi-refresh")]
                          ),
                          _vm._v("Refresh ")
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "pre",
                    {
                      staticClass: "kvm-dk-logs"
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.logs.text ||
                            (_vm.logs.loading ? "Loading…" : "No log output.")
                        )
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "text-right mt-2"
                    },
                    [
                      _c(
                        "gg-btn",
                        {
                          attrs: {
                            text: ""
                          },
                          on: {
                            click: function click($event) {
                              _vm.logs.open = false
                            }
                          }
                        },
                        [_vm._v("Close")]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "440"
          },
          model: {
            value: _vm.remove.open,
            callback: function callback($$v) {
              _vm.$set(_vm.remove, "open", $$v)
            },
            expression: "remove.open"
          }
        },
        [
          _vm.remove.c
            ? _c(
                "gg-card",
                {
                  attrs: {
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": "kvm-dk-rm-title"
                  }
                },
                [
                  _c(
                    "gg-card-text",
                    {
                      staticClass: "pa-4"
                    },
                    [
                      _c(
                        "h3",
                        {
                          staticClass: "body-1 font-weight-medium mb-2",
                          attrs: {
                            id: "kvm-dk-rm-title"
                          }
                        },
                        [_vm._v("Remove " + _vm._s(_vm.remove.c.name) + "?")]
                      ),
                      _c(
                        "p",
                        {
                          staticClass: "mb-2"
                        },
                        [
                          _vm._v(
                            "The container is stopped and deleted. Data in named volumes is kept; anything stored only inside the container is lost."
                          )
                        ]
                      ),
                      _vm.remove.c.stack
                        ? _c(
                            "p",
                            {
                              staticClass: "kvm-help text-caption mb-3"
                            },
                            [
                              _vm._v(
                                " It belongs to the app “" +
                                  _vm._s(_vm.remove.c.stack) +
                                  "” — redeploying the app will create it again. "
                              )
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass: "text-right"
                        },
                        [
                          _c(
                            "gg-btn",
                            {
                              staticClass: "mr-2",
                              attrs: {
                                text: ""
                              },
                              on: {
                                click: function click($event) {
                                  _vm.remove.open = false
                                }
                              }
                            },
                            [_vm._v("Cancel")]
                          ),
                          _c(
                            "gg-btn",
                            {
                              attrs: {
                                tile: "",
                                color: "error"
                              },
                              on: {
                                click: _vm.doRemove
                              }
                            },
                            [_vm._v("Remove")]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "640",
            persistent: ""
          },
          model: {
            value: _vm.run.open,
            callback: function callback($$v) {
              _vm.$set(_vm.run, "open", $$v)
            },
            expression: "run.open"
          }
        },
        [
          _c(
            "gg-card",
            {
              attrs: {
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "kvm-dk-run-title"
              }
            },
            [
              _c(
                "gg-card-text",
                {
                  staticClass: "pa-4"
                },
                [
                  _c(
                    "h3",
                    {
                      staticClass: "body-1 font-weight-medium mb-3",
                      attrs: {
                        id: "kvm-dk-run-title"
                      }
                    },
                    [_vm._v("Run a container")]
                  ),
                  _c("v-text-field", {
                    staticClass: "mb-2",
                    attrs: {
                      label: "Image",
                      placeholder: "nginx:latest",
                      outlined: "",
                      dense: "",
                      hint:
                        "From Docker Hub (nginx, postgres:17) or a registry (ghcr.io/owner/app:tag).",
                      "persistent-hint": ""
                    },
                    model: {
                      value: _vm.run.image,
                      callback: function callback($$v) {
                        _vm.$set(
                          _vm.run,
                          "image",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "run.image"
                    }
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "d-flex flex-wrap"
                    },
                    [
                      _c("v-text-field", {
                        staticClass: "mr-2",
                        staticStyle: {
                          "min-width": "220px"
                        },
                        attrs: {
                          label: "Name (optional)",
                          outlined: "",
                          dense: ""
                        },
                        model: {
                          value: _vm.run.name,
                          callback: function callback($$v) {
                            _vm.$set(
                              _vm.run,
                              "name",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "run.name"
                        }
                      }),
                      _c("v-select", {
                        staticStyle: {
                          "max-width": "200px"
                        },
                        attrs: {
                          items: _vm.restartOptions,
                          label: "Restart",
                          outlined: "",
                          dense: ""
                        },
                        model: {
                          value: _vm.run.restart,
                          callback: function callback($$v) {
                            _vm.$set(_vm.run, "restart", $$v)
                          },
                          expression: "run.restart"
                        }
                      })
                    ],
                    1
                  ),
                  _c("v-combobox", {
                    staticClass: "mb-2",
                    attrs: {
                      label: "Ports",
                      multiple: "",
                      chips: "",
                      "small-chips": "",
                      "deletable-chips": "",
                      outlined: "",
                      dense: "",
                      "append-icon": "",
                      hint:
                        "host:container, e.g. 8080:80 — press Enter after each",
                      "persistent-hint": ""
                    },
                    model: {
                      value: _vm.run.ports,
                      callback: function callback($$v) {
                        _vm.$set(_vm.run, "ports", $$v)
                      },
                      expression: "run.ports"
                    }
                  }),
                  _c("v-combobox", {
                    staticClass: "mb-2",
                    attrs: {
                      label: "Volumes",
                      multiple: "",
                      chips: "",
                      "small-chips": "",
                      "deletable-chips": "",
                      outlined: "",
                      dense: "",
                      "append-icon": "",
                      hint:
                        "name:/path/in/container or /host/path:/path — press Enter after each",
                      "persistent-hint": ""
                    },
                    model: {
                      value: _vm.run.volumes,
                      callback: function callback($$v) {
                        _vm.$set(_vm.run, "volumes", $$v)
                      },
                      expression: "run.volumes"
                    }
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "subtitle-2 mt-2 mb-1"
                    },
                    [_vm._v("Environment variables")]
                  ),
                  _vm._l(_vm.run.env, function(e, i) {
                    return _c(
                      "div",
                      {
                        key: i,
                        staticClass: "d-flex align-center"
                      },
                      [
                        _c("v-text-field", {
                          staticClass: "mr-2 mb-2 kvm-dk-mono",
                          staticStyle: {
                            "max-width": "200px"
                          },
                          attrs: {
                            placeholder: "NAME",
                            outlined: "",
                            dense: "",
                            "hide-details": "",
                            "aria-label": "Variable " + (i + 1) + " name"
                          },
                          model: {
                            value: e.key,
                            callback: function callback($$v) {
                              _vm.$set(
                                e,
                                "key",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "e.key"
                          }
                        }),
                        _c("v-text-field", {
                          staticClass: "mr-2 mb-2",
                          attrs: {
                            placeholder: "value",
                            outlined: "",
                            dense: "",
                            "hide-details": "",
                            "aria-label": "Variable " + (i + 1) + " value"
                          },
                          model: {
                            value: e.value,
                            callback: function callback($$v) {
                              _vm.$set(e, "value", $$v)
                            },
                            expression: "e.value"
                          }
                        }),
                        _c(
                          "gg-btn",
                          {
                            staticClass: "mb-2",
                            attrs: {
                              icon: "",
                              small: "",
                              "aria-label": "Remove variable " + (i + 1)
                            },
                            on: {
                              click: function click($event) {
                                return _vm.run.env.splice(i, 1)
                              }
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              {
                                attrs: {
                                  small: ""
                                }
                              },
                              [_vm._v("mdi-close")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }),
                  _c(
                    "gg-btn",
                    {
                      staticClass: "px-1",
                      attrs: {
                        text: "",
                        small: "",
                        color: "primary"
                      },
                      on: {
                        click: function click($event) {
                          return _vm.run.env.push({
                            key: "",
                            value: ""
                          })
                        }
                      }
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          attrs: {
                            left: "",
                            small: "",
                            "aria-hidden": "true"
                          }
                        },
                        [_vm._v("mdi-plus")]
                      ),
                      _vm._v("Add variable ")
                    ],
                    1
                  ),
                  _vm.run.error
                    ? _c(
                        "v-alert",
                        {
                          staticClass: "mt-3 mb-0",
                          attrs: {
                            type: "warning",
                            dense: "",
                            text: "",
                            role: "alert"
                          }
                        },
                        [_vm._v(_vm._s(_vm.run.error))]
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass: "text-right mt-3"
                    },
                    [
                      _c(
                        "gg-btn",
                        {
                          staticClass: "mr-2",
                          attrs: {
                            text: "",
                            disabled: _vm.run.submitting
                          },
                          on: {
                            click: function click($event) {
                              _vm.run.open = false
                            }
                          }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _c(
                        "gg-btn",
                        {
                          staticClass: "kvm-dk-primary",
                          attrs: {
                            tile: "",
                            color: "primary",
                            loading: _vm.run.submitting,
                            disabled: !_vm.run.image
                          },
                          on: {
                            click: _vm.doRun
                          }
                        },
                        [_vm._v("Run")]
                      )
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }